import React from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

import { money } from './logic';
import { averagePriceTooltip, averageSellPrice, currentPrice } from './priceFormatting';
import { lastPriceAction } from './reviewLogic';
import { CommandDeparture } from './types';

export default function DeparturePrice({ departure }: { departure: CommandDeparture }) {
  const action = lastPriceAction(departure.last_price_action);
  return (
    <Box sx={{ color: 'text.primary', fontVariantNumeric: 'tabular-nums', fontSize: 12 }}>
      <Tooltip title={[averagePriceTooltip(departure), action].filter(Boolean).join('\n')}>
        <Box component="span" tabIndex={0}>
          Avg sold {money(averageSellPrice(departure).all)} / traveller
        </Box>
      </Tooltip>
      <Typography variant="caption" display="block" color="text.secondary">
        Now {currentPrice(departure)}
      </Typography>
    </Box>
  );
}
